<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          :value="applicant[0]"
          color="green"
          icon="mdi-account-group"
          title="Seluruh Kandidat"
          sub-icon="mdi-account-group"
          sub-text="Seluruh kandidat yang sudah melakukan test"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          :value="applicant[1]"
          color="info"
          icon="people"
          title="Kandidat Bulan Ini"
          sub-icon="people"
          sub-text="Seluruh kandidat pada bulan ini"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg4>
        <material-stats-card
          :value="applicant[2]"
          color="red"
          icon="person"
          title="Kandidat Anda"
          sub-icon="person"
          sub-text="Kandidat anda pada bulan ini"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "CDashboard",

  data() {
    return {
      applicant: ""
    };
  },

  created() {
    let url = "dashApplicant";
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios
      .get(url)
      .then(response => {
        let data = response.data.data;
        this.applicant = data;
      })
      .catch(error => {
        let errors = error.response;
        console.log(errors);
      });
  }
};
</script>
